let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kVG1M")).then(() => parcelRequire('kNDd8'));